module.exports = __webpack_public_path__ + "img/close-load-more-active.29ca15ab.svg";